<template>
  <div>
    <div class="container container-fluid">
      <div class="l-promo row">
        <div class="l-promo__col col-md">
          <div
            class="c-promo c-promo--full-width c-promo--bg-triangle c-promo--border c-promo--shadow h-theme--red"
          >
            <aha-loading-spinner :is-loading="isLoading" />
            <div class="row">
              <div class="col-md-6 c-promo--last-sm">
                <div class="c-promo c-promo--match-height">
                  <div class="c-promo__content">
                    <h2 class="h2">{{translations.title}}</h2>
                    <!-- form -->
                    <div>
                      <p>
                        <span class="small form-text text-danger">{{translations.requiredFields}}</span>
                      </p>
                      <aha-stroke-group-selector-form
                        ref="strokeForm1"
                        :endpoint="searchEndpoint"
                        :radius="radius"
                        :translations="translations"
                        :is-visible="isVisible"
                        :on-submit="handleSubmit"
                      ></aha-stroke-group-selector-form>
                    </div>
                    <!-- end form -->
                    <p>{{translations.increaseRadius}}</p>

                    <!-- End Promo Content -->
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="c-promo__media h-placeholder-image h-placeholder-image--bg-sm">
                  <img :src="image" v-lazy-img="image" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End Promo Row -->
    </div>
    <!-- End Container -->

    <!-- Results -->
    <div class="container container-fluid">
      <div class="c-location-selector__mobile-table" aria-live="polite" aria-atomic="true">
        <div v-if="invalidZipCode">
          <div>
            <p>{{translations.zipCodeNotFound}}</p>
          </div>
        </div>
        <div v-else-if="foundlocations.length">
          <div class="c-location-selector__mobile-header">
            <h2 class="c-location-modal__heading h4">
              {{ translations.searchResults }}
              <i>"{{ searchText }}"</i>
            </h2>
            <button
              type="button"
              class="c-cta btn btn-link h-theme--red"
              @click.prevent="clearResults"
              @keydown.enter.prevent="clearResults"
              @keydown.space.prevent="clearResults"
              ref="clearResultsLink"
            >{{ translations.clearResults }}</button>
          </div>

          <aha-stroke-group-selector-table
            ref="results"
            :previousSearchedParams="previousParams"
            :translations="translations"
            :locations="foundlocations"
          ></aha-stroke-group-selector-table>
        </div>
        <div v-else>
          <div v-if="searchClicked > 0 && foundlocations.length === 0">
            <h3>{{translations.noResultsFound}}</h3>
            <p>{{translations.increaseRadius}}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- End Container -->
  </div>
</template>

<script>
import { browserDetails } from '../utils/aha-utils';
import ahaLoadingSpinner from "./aha-loading-spinner.vue";
const browser = browserDetails();
export default {
  components: {
    ahaLoadingSpinner
  },
  data() {
    return {
      searchText: "",
      foundlocations: this.locations,
      isVisible: false,
      searchClicked: 0,
      previousParams: {},
      invalidZipCode: false,
      isLoading: false
    };
  },
  props: {
    showDropdown: {
      type: Boolean,
      default: true
    },
    showModal: {
      type: Boolean,
      default: true
    },
    translations: {
      type: Object,
      required: true,
      default: {
        title: "Find a Stroke Support Group Nearby",
        search: "Search",
        searchResults: "Search results for",
        clearResults: "Clear Results",
        name: "Group Name",
        city: "City",
        state: "State",
        radius: "Radius",
        zipCode: "Zip Code",
        zipCodePlaceholder: "Enter zip code",
        increaseRadius:
          "If your initial search does not pull up any groups, try increasing your mile radius.",
        noResultsFound: "No results found.",
        requiredFields: "All fields are required."
      }
    },
    searchEndpoint: {
      type: String,
      required: true
    },
    radius: {
      type: Array,
      default: () => []
    },
    image: {
      type: String
    },
    locations: {
      type: Array,
      default: []
    },
    previousSearchedParams: {
      type: Object,
      default: {
        zipcode: "",
        radius: "",
        audience: []
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      const data = localStorage.getItem("_aha.last-group-finder");

      if (data) {
        let psoptions = JSON.parse(data);

        if (psoptions.locations && psoptions.locations.length > 0) {
          this.searchClicked = 1;
          this.searchText = psoptions.searchText;
          this.foundlocations = psoptions.locations;
          this.previousParams = {
            radius: psoptions.radius,
            zipcode: psoptions.searchText,
            audience: psoptions.audience
          };
          this.previousSearchedParams = this.previousParams;
        }
      }
    });
    if (this.$props.locations.length > 0) {
      this.$refs.clearResultsLink.focus();
    } else {
      this.$refs.strokeForm1.focusRef(this.$refs.strokeForm1.$refs.input1);
    }
  },
  methods: {
    parse_query_string(query) {
      var vars = query.split("&");
      var query_string = {};
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        var key = decodeURIComponent(pair[0]);
        var value = decodeURIComponent(pair[1]);
        if (typeof query_string[key] === "undefined") {
          query_string[key] = decodeURIComponent(value);
        } else if (typeof query_string[key] === "string") {
          var arr = [query_string[key], decodeURIComponent(value)];
          query_string[key] = arr;
        } else {
          query_string[key].push(decodeURIComponent(value));
        }
      }
      return query_string;
    },
    displayPreviousSearchedParams(name) {
      var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
        window.location.href
      );
      if (results == null) {
        return null;
      } else {
        return decodeURI(results[1]) || 0;
      }
    },
    clearResults(event) {
      this.foundlocations = [];
      this.previousParams = {};
      this.searchText = "";
      this.$refs.strokeForm1.resetForm();
      this.searchClicked = 0;
      this.$refs.results.clearFilters();
    },
    handleSubmit(response) {
      //this.previousParams = {};
      if (response.locations && response.locations.length > 0) {
        var data = JSON.stringify({
          searchText: response.searchText,
          locations: response.locations,
          radius: response.radius
        });

        localStorage.setItem("_aha.last-group-finder", data);
      } else {
        localStorage.removeItem("_aha.last-group-finder");
      }
      this.searchText = response.searchText;
      this.foundlocations = response.locations;
      this.invalidZipCode = response.invalidZipCode;
      this.searchClicked += 1;
      this.isLoading = response.isLoading;
      this.$nextTick(() => {
        if (document.querySelector("fieldset[name='filter']")) {
          const filters = document.querySelector("fieldset[name='filter']");
          const headerTop = document.querySelector('.l-header__top').getBoundingClientRect().height;
          const headerUtility = document.querySelector('.l-header__utility').getBoundingClientRect().height;
          const filtersParent = filters.closest('.container');
          if(browser.mobile) {
              const _mobileBuffer = 50;
              window.scrollTo({top: filtersParent.offsetTop - (Math.round(headerTop + headerUtility + _mobileBuffer))});
          } else {
              window.scrollTo({top: filtersParent.offsetTop - (Math.round(headerTop + headerUtility))});
          }
          filters.focus();
          this.$refs.results.clearFilters();
        }
      });
    },
    hideModal() {
      this.$refs.strokeGroupSelectorModal.hide();
    },
    onShown() {
      this.isVisible = true;
    },
    onHidden() {
      this.isVisible = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/app/components/stroke-group-selector.vue